import { render, staticRenderFns } from "./actFemaleMain.vue?vue&type=template&id=5fbb1944&scoped=true"
import script from "./actFemaleMain.vue?vue&type=script&lang=js"
export * from "./actFemaleMain.vue?vue&type=script&lang=js"
import style0 from "./actFemaleMain.vue?vue&type=style&index=0&id=5fbb1944&prod&lang=less&scoped=true"
import style1 from "./actFemaleMain.vue?vue&type=style&index=1&id=5fbb1944&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbb1944",
  null
  
)

export default component.exports